import { Injectable } from '@angular/core';
import { WebApiService } from '../../../../shared/services/web-api.service';
import { SettingsService } from 'src/app/views/settings/settings.service';
import { sessionService } from './session.service';
import { Page } from 'src/app/shared/models/page';
import { Observable, from } from 'rxjs';
import { PagedData, PagedDataUserMenu } from 'src/app/shared/models/paged-data';
import { HttpErrorResponse, HttpParams } from '@angular/common/http';
import { menuPageParams, PageParams } from 'src/app/shared/common/Enums';

@Injectable({
  providedIn: 'root'
})
export class SupplierService {

  keyword: string = '';
  supplierKeyword: string = '';
  productKeyword: string = '';
  countryPortsearchKeyword: string = '';
  constructor(
    private webApiService: WebApiService,
    private settingService: SettingsService,
    private guestSession: sessionService,

    ) { }

  async getSearchKeywordsFilteredImpa(searchKeyword: any) {
    // console.log(searchKeyword);
    // let apiUrl = `/search/serchItems/${searchKeyword}`;
    // return this.webApiService.getRequest<any>(apiUrl);
    if(searchKeyword===null){
      this.keyword = ''
    }
    else{
      this.keyword=searchKeyword;
    }
    
    return this.settingService.getSearchImpaItems(this.keyword,'impa');
    
    
  }

//   getImpaCatalogue(categoryId: any): Promise<any> {
//     let apiUrl = `/impa/fetchDetails`;
//     return this.webApiService.postRequest<any>(apiUrl, {
//       categoryIds: categoryId
//     });
//   }

  async getSearchKeywordsFilteredSupplier(searchKeyword: any) {

    if (searchKeyword === null) {
      this.supplierKeyword = ''
    }
    else {
      this.supplierKeyword = searchKeyword;
    }

    return this.settingService.getSearchImpaItems(this.supplierKeyword, 'supplier');


  }

  async getSearchKeywordsFilteredMySupplier(searchKeyword: any,userId:number) {

    if (searchKeyword === null) {
      this.supplierKeyword = ''
    }
    else {
      this.supplierKeyword = searchKeyword;
    }

    return this.settingService.getSearchImpaItemsMySupplier(this.supplierKeyword, 'mySupplier', userId);


  }

  async getSearchKeywordsFilteredProduct(searchKeyword: any) {

    if (searchKeyword === null) {
      this.productKeyword = ''
    }
    else {
      this.productKeyword = searchKeyword;
    }

    return this.settingService.getSearchImpaItems(this.productKeyword, 'product');


  }

  async getSearchKeywordsFilteredCountryPort(searchKeyword: any) {

    if (searchKeyword === null) {
      this.countryPortsearchKeyword = ''
    }
    else {
      this.countryPortsearchKeyword = searchKeyword;
    }

    return this.settingService.getSearchCountryPorts(this.countryPortsearchKeyword, 'countryPort');


  }   

  async addRecentSearchHistory(reqBody: any) {

    const res: any = await this.settingService.addRecentSearchHistory(reqBody);
    // a guest's first search (or one under an old browser-made id) comes back with the API-issued history id
    if (!reqBody?.userId && res?.sessionId) this.guestSession.storeGuestSessionId(res.sessionId);
    return res;

  } 

  async fetchUserSearchHistory(userId?: number, sessionId?:string) {

    return this.settingService.fetchUserSearchHistory(userId,sessionId);

  }  
  
  async fetchAllMainCategory(
    filterValue: string,
    limit: number,
    offset: number
  ): Promise<any> {
    let _pageMetadata = new Page();
    let apiUrl = '/categories/getAllMainCategories'

    let params = new HttpParams()
      .set(PageParams.limit, limit)
      .set(PageParams.page, offset + 1)
      .set(PageParams.searchParam, filterValue)
      .set(PageParams.isImpa, false);
    return this.webApiService.getRequest1<any>(
      apiUrl,
      params
    );
  }

  async fetchAllMainBrand(
    filterValue: string,
    limit: number,
    offset: number
  ): Promise<any> {
    let _pageMetadata = new Page();
    let apiUrl = '/brands/getAllMainBrands'

    let params = new HttpParams()
      .set(PageParams.limit, limit)
      .set(PageParams.page, offset + 1)
      .set(PageParams.searchParam, filterValue)
      .set(PageParams.isImpa, false);
    return this.webApiService.getRequest1<any>(
      apiUrl,
      params
    );
  }


}